/**
 * Opens the Intercom chat widget.
 *
 * This function checks if the `Intercom` function exists on the `window` object.
 * If it is, it calls the `Intercom` function with the argument `'show'` to open the `Intercom` chat widget.
 *
 */
export const openChat = (): void => {
  if (typeof window['Intercom' as keyof Window] === 'function') {
    window['Intercom' as keyof Window]('show');
  }
};
